/**
 * Событие store_click — клик по ссылке на наше расширение в сторе.
 *
 * Зачем: до 08.10.2026 GA4 видел только просмотры страниц, и вопрос
 * «сколько людей из поиска ушли ставить расширение» был без ответа —
 * а это итоговая цель всей SEO-работы (SEO_GOAL.md, точка 15.03.2027).
 *
 * Ссылок на стор на сайте больше десятка, и новые появляются с каждым
 * лендингом, поэтому слушаем клики на уровне документа, а не расставляем
 * обработчики по компонентам. Считаем только наше расширение: в обзоре
 * расширений есть ссылки на чужие, их клики сюда не попадают.
 *
 * Отправка работает с обоими тегами из Html.js: gtag (G-…) и старым
 * analytics.js (UA-…), который Google переносит в GA4 — там имя события
 * берётся из eventAction, как уже видно на событиях Invite.
 */

const CHROME_ID = 'epngggilgnflanfabeldfpbgponcgpgl';
const FIREFOX_SLUG = 'new-tab-studio-countdown';

export const EVENT_NAME = 'store_click';

/** 'chrome' | 'firefox' | null */
export function storeOf(href) {
	if (typeof href !== 'string') return null;

	if (href.indexOf(CHROME_ID) !== -1) return 'chrome';
	if (
		href.indexOf('addons.mozilla.org') !== -1 &&
		href.indexOf(FIREFOX_SLUG) !== -1
	) {
		return 'firefox';
	}

	return null;
}

function findLink(node) {
	let el = node;
	while (el && el.nodeType === 1) {
		if (el.tagName === 'A' && el.href) return el;
		el = el.parentNode;
	}
	return null;
}

export function sendStoreClick(win, store, path) {
	if (typeof win.gtag === 'function') {
		win.gtag('event', EVENT_NAME, {
			store,
			page_path: path,
			transport_type: 'beacon',
		});
	} else if (typeof win.ga === 'function') {
		win.ga('send', 'event', 'Store', EVENT_NAME, `${store} ${path}`, {
			transport: 'beacon',
		});
	}
}

export default function trackStoreClicks(doc = document, win = window) {
	const onClick = event => {
		// Средняя кнопка тоже открывает стор — в новой вкладке
		if (event.type === 'auxclick' && event.button !== 1) return;

		const link = findLink(event.target);
		const store = link && storeOf(link.href);
		if (!store) return;

		sendStoreClick(win, store, win.location.pathname);
	};

	// Фаза захвата: событие дойдёт до нас, даже если компонент
	// остановит всплытие
	doc.addEventListener('click', onClick, true);
	doc.addEventListener('auxclick', onClick, true);
}
